import axios from 'axios';

export const submitClientRequest = async (payload) => {
  let response;

  try {
    response = await axios.post(process.env.NEXT_PUBLIC_API + '/client', payload);
  } catch (error) {
    if (typeof window === 'object') {
      window.alert(error.response?.data?.text || 'Не удалось отправить заявку');
    }

    return false;
  }

  if (response?.data?.status === 'ok') {
    if (typeof ym === 'function') {
      ym(21340345, 'reachGoal', 'all_form_submit');
    }

    return true;
  }

  if (response?.data?.status !== 'cancelled' && typeof window === 'object') {
    window.alert(response?.data?.text || 'Не удалось отправить заявку');
  }

  return false;
};
